import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { WorksTermsProvider } from 'components/works/context';
import Modal from './components/modal/Modal';
import * as FL from './lib/FL';
import ModalProvider from './contexts/ModalProvider';
import MetaSetting from './components/atom/MetaSetting';
import ContentSamplePage from './pages/ContentSamplePage';
import Header from './components/layouts/Header';
import Nav from './components/layouts/Nav';
import Sidebar from './components/layouts/Sidebar';
import Footer from './components/layouts/Footer';
import ContentsPage from './pages/ContentsPage';
import SetPage from './pages/SetPage';
import DesignsPage from './pages/DesignsPage';
import MainImagePage from './pages/MainImagePage';
import ErrorPage from './pages/error/ErrorPage';
import styles from './App.module.scss';
import WorksPage from './pages/WorksPage';

const App: React.FC = () => {
  const [data, setData] = useState<FL.APIDataProps>();
  const [loaded, setLoaded] = useState<boolean>(false);
  const [isError, setError] = useState<boolean>(false);

  useEffect(() => {
    FL.get()
      .then((apiData) => {
        setData(apiData);
        setLoaded(true);
      })
      .catch((error) => {
        setLoaded(true);
        setError(true);
      });
  }, []);

  const ScrollTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
    return null;
  };

  const MainSwitch = () => (
    <Switch>
      <Route path={['/set', '/basic']}>
        <SetPage contents={data?.basic.contents} options={data?.basic.options} />
      </Route>
      <Route path='/contents'>
        <ContentsPage basicContents={data?.basic.contents} contentCategories={data?.content_categories} />
      </Route>
      <Route path={['/', '/designs/:business?']} exact>
        <DesignsPage designs={data?.designs} />
      </Route>
      <Route path='/works'>
        <WorksPage />
      </Route>
      <Redirect to='/' />
    </Switch>
  );
  return (
    <div className={styles.app}>
      <ModalProvider>
        <WorksTermsProvider>
          <Router>
            <Switch>
              <Route path='/content/:enName/(detail)?/:device?'>
                {data && <ContentSamplePage contentsData={FL.getAllContentsFromApiData(data)} />}
              </Route>
              <Route path='/mainimage'>
                <MetaSetting title='ホームページ制作 メイン画像カタログ' isNoIndex />
                <MainImagePage />
              </Route>
              <Route>
                <ScrollTop />
                <Header />
                <Nav />
                <Sidebar />
                <div className={styles.app__main}>
                  {isError ? <ErrorPage /> : <MainSwitch />}
                  <Footer />
                </div>
                {!loaded && <div className={styles.overlay} />}
                <Modal />
              </Route>
            </Switch>
          </Router>
        </WorksTermsProvider>
      </ModalProvider>
    </div>
  );
};

export default App;
